// extracted by mini-css-extract-plugin
module.exports = {"remove-account__text":"styles_remove-account__text__2g8Zu","remove-account__button":"styles_remove-account__button__3gat5"};